export default __webpack_public_path__ + "KaTeX_SansSerif-Italic.c834ba6da13819f078ec34f212d081e3.woff";